import { Sport, SPORT_LABELS } from '@/types';
import { cn } from '@/lib/utils';
import pickleballIcon from '@/assets/pickleball-icon.png';

interface SportBadgeProps {
  sport: Sport;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  iconOnly?: boolean;
}

const sportEmojis: Record<Sport, string> = {
  football: '⚽',
  volleyball: '🏐',
  badminton: '🏸',
  tabletennis: '🏓',
  tennis: '🎾',
  pickleball: '',
  basketball: '🏀',
  swimming: '🏊',
  golf: '⛳',
  billiards: '🎱',
  running: '🏃',
  cycling: '🚴',
};

const sizeStyles = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg'
};

const iconSizes = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6'
};

export function SportBadge({
  sport,
  className,
  size = 'md',
  iconOnly = false
}: SportBadgeProps) {
  const renderIcon = () => {
    if (sport === 'pickleball') {
      return <img src={pickleballIcon} alt="Pickleball" className={cn(iconSizes[size], 'inline-block')} />;
    }
    return <span className={sizeStyles[size]}>{sportEmojis[sport]}</span>;
  };

  if (iconOnly) {
    return (
      <span className={cn(sizeStyles[size], className)}>
        {renderIcon()}
      </span>
    );
  }

  return (
    <span className={cn(
      'inline-flex items-center gap-1 text-xs text-muted-foreground',
      className
    )}>
      {renderIcon()}
      <span>{SPORT_LABELS[sport]}</span>
    </span>
  );
}
